import NavPanel from "../NavPanel";
import Logo from "components/Logo";
import { useTabs } from "./../../useTabs";
import "./AppFooter.css";
import { useRouteMeta } from "utils/routing";
import { WEBSITE_ROUTES } from "pages/routes";
import { useTranslation } from "react-i18next";
import { isCookieConsentEnabled, renewCookieConsent } from "services/cookieConsent";

/**
 * A default page's footer with a copyright and navigation links.
 * It also supports languages panel but it's disabled for now.
 */

export default function AppFooter() {
  const { textTabs } = useTabs();
  const routeMeta = useRouteMeta();
  const { t } = useTranslation();

  if (routeMeta.footer === false) {
    return null;
  }

  if (routeMeta.footer === "small") {
    return (
      <div className="app-small-footer">
        <div>
          <Logo />
        </div>
        <div className="copyright">
          Copyright Talaera {new Date().getFullYear()}. All rights reserved.
        </div>
      </div>
    );
  }

  return (
    <div className="app-footer" style={{ bottom: 0 }}>
      <div className="footer-content">
        <div className="tabs-panel">
          <div>
            <Logo />
          </div>
          <NavPanel tabs={textTabs} linkClassName="webapp" />
        </div>
        <div className="terms-panel">
          <span className="terms-privacy">
            <LegalLink
              label={t("Common.footer.terms")}
              documentUrl={WEBSITE_ROUTES.termsOfService}
            />
            <LegalLink
              label={t("Common.footer.privacy")}
              documentUrl={WEBSITE_ROUTES.privacyPolicy}
            />
            <LegalLink
              label={t("Common.footer.cookies")}
              documentUrl={WEBSITE_ROUTES.cookiePolicy}
            />
            {isCookieConsentEnabled() && (
              <CookieConsentLink label={t("Common.footer.cookiePreferences")} />
            )}
            <LegalLink
              label={t("Common.footer.imprint")}
              documentUrl={WEBSITE_ROUTES.imprint}
            />
          </span>
        </div>
        <div>
          <div className="copyright-wrapper">
            <span className="copyright">
              Copyright Talaera {new Date().getFullYear()}. All rights reserved.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

type LegalLinkProps = {
  documentUrl: string;
  label: string;
};

function LegalLink(props: LegalLinkProps) {
  return (
    <a href={props.documentUrl} target="_blank" rel="noopener noreferrer">
      {props.label}
    </a>
  );
}

type CookieConsentLinkProps = {
  label: string;
};

function CookieConsentLink(props: CookieConsentLinkProps) {
  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();
    renewCookieConsent();
  };

  return (
    <a href="#cookie-preferences" onClick={handleClick}>
      {props.label}
    </a>
  );
}
